import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checkmark--black",
  "use": "icon-checkmark--black-usage",
  "viewBox": "0 0 30 31",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 31\" id=\"icon-checkmark--black\"><circle cx=\"15\" cy=\"15.942\" r=\"12.5\" fill=\"#000\" /><path d=\"m10 17.045 2.609 2.647 7.391-7.5\" stroke=\"#fff\" stroke-width=\"1.613\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol